const LAST_WORKSPACE_SLUG_KEY = 'vizit.last-workspace-slug';

export function rememberLastWorkspaceSlug(workspaceSlug: string): void {
  try {
    window.localStorage.setItem(LAST_WORKSPACE_SLUG_KEY, workspaceSlug);
  } catch {
    return;
  }
}

export function readLastWorkspaceSlug(): string | null {
  try {
    return window.localStorage.getItem(LAST_WORKSPACE_SLUG_KEY);
  } catch {
    return null;
  }
}

export { LAST_WORKSPACE_SLUG_KEY };
